export enum ManageUsersAnalyticsMessages {
  event = 'submit form',
  capability = 'shared services',
  removeUser = 'manage users:remove user',
  removeAdmin = 'manage users:remove admin',
  makeAdmin = 'manage users:make admin',
}
